import React, { useState, useEffect, useContext } from "react";
import * as S from "./styles";

import PessoaJuridica from "../../assets/navbar/Pessoa_juridica_on.svg";
import Usuario from "../../assets/navbar/Usuario_on.svg";
import Convenios from "../../assets/navbar/Convenios_on.svg";
import Regional from "../../assets/navbar/Regional_on.svg";
import LupaOn from "../../assets/navbar/Lupa_on.svg";

import Button from "../../components/Button";
import SkeletonListItem from "../SkeletonListItem";

import api from "../../services/api";
import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import InputMask from "react-input-mask";
import { toast } from "react-toastify";

import { Context } from "../../context/globalContext";
import { mask } from "../../utils/mask";
import desmaskIfNumber from "../../utils/desmaskIfNumber";

import BorderForSelectNumberOfRecords from "../BorderForSelectNumberOfRecords";
import BorderForSort from "../BorderForSort";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";
import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../Button-v2";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function ListRegional({ history, pageFilter, filter }) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { pageLimit, setPageLimit } = useContext(Context);

  const [regionais, setRegioais] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(0);

  const [orderDirection, setorderDirection] = useState("ASC");
  const [orderByColumn, setorderByColumn] = useState("nome_regional");
  const [sortIndex, setSortIndex] = useState(0);

  async function getDataByRegionaiscnpj(cpfCnpj, page) {
    try {
      setIsLoading(true);
      const response = await api.get(
        `api/regional/buscar?cnpjOuNome=${cpfCnpj || ""}&page=${
          page || 0
        }&size=${pageLimit}&sort=${orderByColumn},${orderDirection}`
      );

      if (response && (response.status === 201 || response.status === 200)) {
        setRegioais(response.data.content);
        setPage(page || 0);
        setTotalPages(response.data.totalPages);
        setTotalElements(response.data.totalElements);
      } else if (!response) {
        setRegioais([]);
        setPage(page || 0);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Erro ao buscar regionais.");
      }

      setIsLoading(false);
    } catch (err) {
      setTotalPages(0);
      setPage(page || 0);
      setTotalElements(0);
      setRegioais([]);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar regionais.");
      }
    }
    setLoading(+1);
  }

  useEffect(() => {
    if (filter) {
      setSearch(filter);
    }

    if (pageFilter) {
      setPage(pageFilter);
    }

    loadUser(filter, pageFilter);
  }, [filter, pageFilter, pageLimit, sortIndex]);

  async function loadUser(cpfCnpj, page) {
    getDataByRegionaiscnpj(cpfCnpj, page);
  }

  const reloadPage = (filter, page) => {
    history.replace(
      `?filter=${desmaskIfNumber(filter)}${
        page && page > 0 ? "&page=" + page : ""
      }`
    );
  };

  const selectNumberRegistry = async (item) => {
    setPageLimit(item.id);
  };

  const handleKeyPress = (event) => {
    const value = event.target.value;
    if (event.key === "Enter") {
      reloadPage(value);
    }
  };

  const verifyIfIsEnabled = (pessoaJuridica, entity, image, url) => {
    if (!pessoaJuridica || pessoaJuridica === null) {
      return <S.SvgIconDisabled src={image} alt="" />;
    }

    if (
      pessoaJuridica &&
      (!pessoaJuridica?.tipoEntityPessoa ||
        pessoaJuridica?.tipoEntityPessoa === null)
    ) {
      return <S.SvgIconDisabled src={image} alt="" />;
    }

    if (pessoaJuridica && pessoaJuridica?.tipoEntityPessoa) {
      let pessoaJuridicaSearched = pessoaJuridica?.tipoEntityPessoa.find(
        (x) => x.papelPessoaJuridica === entity
      );
      if (pessoaJuridicaSearched && pessoaJuridicaSearched !== null) {
        return (
          <S.SvgIcon
            onClick={() => {
              history.push(`/${url}`);
            }}
            src={image}
            alt=""
          />
        );
      }
    }

    return <S.SvgIconDisabled src={image} alt="" />;
  };

  const selectSort = async (item) => {
    setSortIndex(item.id);

    switch (item.sort) {
      case "DESC":
        setorderByColumn("nome");
        setorderDirection("DESC");
        break;
      case "ASC":
        setorderByColumn("nome");
        setorderDirection("ASC");
        break;
      case "DataDESC":
        setorderByColumn("nome_regional");
        setorderDirection("DESC");
        break;
      case "DataASC":
        setorderByColumn("nome_regional");
        setorderDirection("ASC");
        break;
    }
  };

  return (
    <>
      <S.Container>
        <S.Card>
          <div className="boxSearch">
            <S.SvgIcon src={LupaOn} className="lupa" />
            <InputMask
              type="text"
              name="search"
              alwaysShowMask={false}
              value={search}
              onKeyPress={(e) => handleKeyPress(e)}
              onChange={(ev) => setSearch(ev.target.value)}
            />
            <Button type="button" onClick={() => reloadPage(search)}>
              Buscar por CNPJ ou nome
            </Button>
          </div>
          <S.CardHeader>
            <span>
              {`${totalElements} ${totalElements > 1 ? "" : ""} cadastro${
                totalElements > 1 ? "s" : ""
              } no sistema`}
            </span>
            {totalElements > 0 && (
              <span className="border">
                Selecione o icone para acessar o cadastro
              </span>
            )}
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {regionais &&
                regionais?.map((regionais) => {
                  return (
                    <>
                      <S.Custumer>
                        <S.Info
                          onClick={() =>
                            history?.push(
                              `/cadastro-regionais/${regionais?.pessoa?.id}`
                            )
                          }
                        >
                          <S.SvgIcon src={Regional} alt="" />
                          <div className="dataCard">
                            <h4>CNPJ:</h4>
                            <h4>Nome:</h4>
                          </div>
                          <div className="dataCard">
                            <h4 className="h4-info">
                              {mask(
                                regionais?.pessoa?.cpfCnpj,
                                regionais?.pessoa?.cpfCnpj.length > 11
                                  ? "##.###.###/####-##"
                                  : "###.###.###-##",
                                true
                              )}
                            </h4>
                            <h4 className="h4-info">
                              {regionais?.nomeRegional +
                                " | " +
                                regionais?.pessoa?.nome}
                            </h4>
                          </div>
                        </S.Info>

                        {regionais?.status ? (
                          <div className="iconService">
                            <Button
                              type="button"
                              onClick={() => {
                                history.push(
                                  `/cadastro-usuario?cnpj=${desmaskIfNumber(
                                    regionais?.pessoa?.cpfCnpj
                                  )}`
                                );
                              }}
                            >
                              <S.SvgIconInvert src={Usuario} alt="" />
                              Adicionar usuário
                            </Button>
                            <S.SvgIcon
                              onClick={() => {
                                if (
                                  !regionais?.pessoa ||
                                  regionais?.pessoa === null
                                ) {
                                  toast.error(
                                    "Este regional não possui uma pessoa jurídica vinculada!"
                                  );
                                  return;
                                }

                                history.push(
                                  `/cadastro-pessoa-juridica/${regionais?.pessoa?.id}`
                                );
                              }}
                              src={PessoaJuridica}
                              alt=""
                            />
                            {verifyIfIsEnabled(
                              regionais?.convenio?.pessoa,
                              "CONVENIO",
                              Convenios,
                              `cadastro-convenios/${regionais.convenio?.pessoa?.id}`
                            )}
                          </div>
                        ) : (
                          <div className="WrapperInativo">
                            <Button className="inativo">
                              Cadastro Inativo
                            </Button>
                          </div>
                        )}
                      </S.Custumer>
                    </>
                  );
                })}
              <div className="rodaPe">
                <div className="select1">
                  <S.SelectContainer>
                    <BorderForSelectNumberOfRecords
                      selected={0}
                      handleSearch={selectNumberRegistry}
                      initialValue={pageLimit}
                    />
                  </S.SelectContainer>
                </div>
                <div className="select">
                  <S.SelectContainer>
                    <BorderForSort
                      selected={0}
                      handleSearch={selectSort}
                      initialValue={sortIndex}
                    />
                  </S.SelectContainer>
                </div>
                <div className="select">
                  {totalPages > 1 && (
                    <TablePagination
                      component="div"
                      classes={{
                        toolbar: classes.toolbar,
                        caption: classes.caption,
                      }}
                      count={totalElements}
                      page={page}
                      labelDisplayedRows={({ from, to, count }) => {
                        return from + " - " + to + " de " + count;
                      }}
                      onPageChange={(p, newPage) => reloadPage(search, newPage)}
                      rowsPerPageOptions={[10]}
                      rowsPerPage={pageLimit}
                    />
                  )}
                </div>
              </div>
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Card>
      </S.Container>
    </>
  );
}
